import { useContext } from "react";
import { Button, InputText, Password } from "iuvity-ui-components";
import { Controller, useForm } from "react-hook-form";
import { validationPassword, validationUser } from "./validations";
import LoginFormError from "./extras/LoginFormError";
import { AppContext } from "../../context/index";
import users from "../../data/users.json";
import styles from "./login.module.scss";

export const LoginForm = () => {
  const { t, toast, setAppState } = useContext(AppContext);

  const { control, formState, getValues } = useForm({
    mode: "onChange",
    delayError: 1200,
    reValidateMode: "onChange",
    defaultValues: {
      username: "",
      password: "",
    },
  });

  const onLogin = (e: any) => {
    e.preventDefault();
    const { username: user, password: pass } = getValues();
    const currentDate = new Date(Date.now()).getTime();
    setAppState((prev) => ({
      ...prev,
      isLoading: true,
    }));
    const sUser = (
      process.env["REACT_APP_USERS"]
        ? JSON.parse(process.env["REACT_APP_USERS"])
        : users
    ).find(
      ({ username, password }: any) =>
        JSON.stringify([username, password]) === JSON.stringify([user, pass])
    );
    setTimeout(() => {
      if (sUser) {
        setAppState((prev) => ({
          ...prev,
          user: {
            name: sUser.name,
            lastname: sUser.lastmane,
            avatarURL: `https://ui-avatars.com/api/?name=${sUser.name.replace(
              /\s/g,
              "+"
            )}`,
            userId: sUser.userId
          },
          isLoading: false,
        }));
        sessionStorage.setItem("SESSIONID", `${currentDate}`);
        sessionStorage.setItem("CORRELATION", `${currentDate}`.substring(0, 2));
      } else {
        setAppState((prev) => ({
          ...prev,
          isLoading: false,
        }));
        toast.current.replace({
          severity: "error",
          summary: "",
          detail: t("Login.invalidCredentialsErrorMessage"),
          life: 3000,
        });
      }
    }, 1500);
  };

  return (
    <form
      className={styles.form}
      onPaste={(e) => e.preventDefault()}
      onCopy={(e) => e.preventDefault()}
    >
      <Controller
        key={"UsernameInput"}
        control={control}
        name={"username"}
        rules={validationUser(t)}
        render={({ field, fieldState }) => (
          <div className={styles.formControl}>
            <InputText
              {...field}
              id={"UsernameInput"}
              label={t("Login.userNameLabel")}
              placeholder={t("Login.userNamePlaceHolder")}
              value={field.value || ""}
              required={true}
              className={
                formState.errors["username"]?.type !== "required" &&
                fieldState.error
                  ? "pt p-invalid"
                  : "pt"
              }
              style={{
                width: "100%",
              }}
              autoComplete="one-time-code"
            />
            <LoginFormError
              fieldErrors={formState.errors as any}
              inputName="username"
            />
          </div>
        )}
      />

      <Controller
        key={"PasswordInput"}
        control={control}
        name={"password"}
        rules={validationPassword(t)}
        render={({ field, fieldState }) => (
          <div className={styles.formControl}>
            <Password
              {...field}
              id={"PasswordInput"}
              label={t("Login.passwordLabel")}
              placeholder={t("Login.passwordPlaceHolder")}
              keyfilter={/^[A-Za-z0-9#.!_@-]*$/}
              value={field.value || ""}
              maxLength={16}
              required={true}
              className={
                formState.errors["password"]?.type !== "required" &&
                fieldState.error
                  ? "p-invalid"
                  : ""
              }
              style={{
                width: "100%",
              }}
              autoComplete="one-time-code"
            />
            <LoginFormError
              fieldErrors={formState.errors as any}
              inputName="password"
            />
          </div>
        )}
      />

      <div className={styles.formActions}>
        <Button
          id="login-button"
          variant="p-button"
          label={t("Login.loginButton")}
          disabled={!formState.isValid}
          onClick={onLogin}
        />
      </div>
    </form>
  );
};
